import React from 'react';

const COLORS = {
  OK:      { bg: '#dcfce7', color: '#16a34a', border: '#86efac' },
  FAILED:  { bg: '#fef2f2', color: '#dc2626', border: '#fca5a5' },
  WARNING: { bg: '#fefce8', color: '#ca8a04', border: '#fde047' },
  RUNNING: { bg: '#eff6ff', color: '#2563eb', border: '#93c5fd' },
  UNKNOWN: { bg: '#f1f5f9', color: '#64748b', border: '#cbd5e1' },
};

export default function StatusBadge({ status }) {
  const s = String(status || 'UNKNOWN').toUpperCase();
  const c = COLORS[s] || COLORS.UNKNOWN;
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 700,
      background: c.bg,
      color: c.color,
      border: `1px solid ${c.border}`,
      letterSpacing: '0.03em',
    }}>
      {s === 'RUNNING' ? '⏳ ' : ''}{s}
    </span>
  );
}
